import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Menu from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Menu';
import MenuItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/MenuItem';
import Tab from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tab';

const styles = theme => ({
  root: {
    opacity: 1,
    minWidth: 0,
  },
  rootWithOnClose: {
    paddingRight: theme.spacing(4),
  },
  tabCloseButton: {
    padding: theme.spacing(0.5),
  },
});

const ColumnTab = ({
  className,
  classes,
  onClose,
  tabIndex,
  tabName,
  contextMenuItems: contextMenuItemsProp,
  style,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const contextMenuItems = contextMenuItemsProp.filter(v => !v.hide);

  return (
    <Draggable
      draggableId={tabName}
      index={tabIndex}
      key={tabName}
    >
      {provided => (
        <>
          <Tab
            classes={{
              root: classNames(classes.root, className, {
                [classes.rootWithOnClose]: !!onClose,
              }),
              tabCloseButton: classes.tabCloseButton,
            }}
            disableRipple
            onContextMenu={(evt) => {
              evt.preventDefault();
              setAnchorEl(evt.currentTarget);
            }}
            onClose={onClose}
            ref={provided.innerRef}
            showTooltip
            {...rest}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...style,
              ...provided.draggableProps.style,
            }}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => {
              setAnchorEl(null);
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            getContentAnchorEl={null} // See https://github.com/mui-org/material-ui/issues/19245#issuecomment-620488016
          >
            {contextMenuItems.map((config, i) => {
              return (
                <MenuItem
                  disabled={config.disabled}
                  key={`menu-item.${i}`} // eslint-disable-line react/no-array-index-key
                  onClick={() => {
                    config.onClick(tabName);
                    setAnchorEl(null);
                  }}
                >
                  {config.label}
                </MenuItem>
              );
            })}
          </Menu>
        </>
      )}
    </Draggable>
  );
};

ColumnTab.defaultProps = {
  className: '',
  onClose: null,
};

ColumnTab.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  contextMenuItems: PropTypes.array.isRequired,
  onClose: PropTypes.func,
  tabIndex: PropTypes.number.isRequired,
  tabName: PropTypes.string.isRequired,
};

export default withStyles(styles)(ColumnTab);
